import monitorApi from '@/api/monitor';

const state = {
    list: null,
    listDeal: null,
    listTask: null,
    monitorInfo: null,
    isLoading: false,
    validationErrors: null,
    monitorHistory:null,
    opened:null
}

export const mutationTypes = {
    getNewRequestsStart: '[newRequests] Get new requests start',
    getNewRequestsSuccess: '[newRequests] Get new requests success',
    getNewRequestsFailure: '[newRequests] Get new requests failure',

    getProgressRequestsStart: '[progressRequests] Get progress requests start',
    getProgressRequestsSuccess: '[progressRequests] Get progress requests success',
    getProgressRequestsFailure: '[progressRequests] Get progress requests failure',

    getNotaskDealsStart: '[notaskDeals] Get notask deals start',
    getNotaskDealsSuccess: '[notaskDeals] Get notask deals success',
    getNotaskDealsFailure: '[notaskDeals] Get notask deals failure',

    getActiveDealsStart: '[activeDeals] Get active deals start',
    getActiveDealsSuccess: '[activeDeals] Get active deals success',
    getActiveDealsFailure: '[activeDeals] Get active deals failure',

    getMonitorInfoStart: '[monitorInfo] Get monitor info start',
    getMonitorInfoSuccess: '[monitorInfo] Get monitor info success',
    getMonitorInfoFailure: '[monitorInfo] Get monitor info failure',

    getNewTasksStart: '[newTasks] Get new tasks start',
    getNewTasksSuccess: '[newTasks] Get new tasks success',
    getNewTasksFailure: '[newTasks] Get new tasks failure',

    getOverdueTasksStart: '[overdueTasks] Get overdue tasks start',
    getOverdueTasksSuccess: '[overdueTasks] Get overdue tasks success',
    getOverdueTasksFailure: '[overdueTasks] Get overdue tasks failure',

    getActiveClientsStart: '[activeClients] Get active clients start',
    getActiveClientsSuccess: '[activeClients] Get active clients success',
    getActiveClientsFailure: '[activeClients] Get active clients failure',

    getNodealClientsStart: '[nodealClients] Get nodeal clients start',
    getNodealClientsSuccess: '[nodealClients] Get nodeal clients success',
    getNodealClientsFailure: '[nodealClients] Get nodeal clients failure',

    getNotaskClientsStart: '[notaskClients] Get notask clients start',
    getNotaskClientsSuccess: '[notaskClients] Get notask clients success',
    getNotaskClientsFailure: '[notaskClients] Get notask clients failure',

    getListDealStart: '[listDeal] Get list deal start',
    getListDealSuccess: '[listDeal] Get list deal success',
    getListDealFailure: '[listDeal] Get list deal failure',

    getListTaskStart: '[listTask] Get list task start',
    getListTaskSuccess: '[listTask] Get list task success',
    getListTaskFailure: '[listTask] Get list task failure',

    getDealsStageStart: '[dealsStage] Get deals stage start',
    getDealsStageSuccess: '[dealsStage] Get deals stage success',
    getDealsStageFailure: '[dealsStage] Get deals stage failure',

    getMonitorHistoryStart: '[monitorHistory] Get monitor start',
    getMonitorHistorySuccess: '[monitorHistory] Get monitor success',
    getMonitorHistoryFailure: '[monitorHistory] Get monitor failure',

    setOpenedStart: '[setOpened] Set opened start',
    setOpenedSuccess: '[setOpened] Set opened success',
    setOpenedFailure: '[setOpened] Set opened failure'
}

export const monitorActionTypes = {
    getNewRequests: '[newRequests] Get new requests list',
    getProgressRequests: '[progressRequests] Get progress requests list',
    getNotaskDeals: '[notaskDeals] Get notask deals list',
    getActiveDeals: '[activeDeals] Get active deals list',
    getMonitorInfo: '[monitorInfo] Get monitor',
    getNewTasks: '[newTasks] Get new tasks',
    getOverdueTasks: '[overdueTasks] Get overdue tasks',
    getActiveClients: '[activeClients] Get active clients',
    getNodealClients: '[nodealClients] Get nodeal clients',
    getNotaskClients: '[notaskClients] Get notask clients',
    getListDeal: '[listDeal] Get list deal',
    getListTask: '[listTask] Get list task',
    getDealsStage: '[dealsStage] Get deals stage',
    getMonitorHistory: '[monitorHistory] Get monitor history',
    setOpened: '[setOpened] Set opened'
}

const mutations = {
    [mutationTypes.getNewRequestsStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.getNewRequestsSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getNewRequestsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getProgressRequestsStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.getProgressRequestsSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getProgressRequestsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getNotaskDealsStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.getNotaskDealsSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getNotaskDealsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getActiveDealsStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.getActiveDealsSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getActiveDealsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getMonitorInfoStart](state) {
        state.isLoading = true
        state.monitorInfo = null
    },
    [mutationTypes.getMonitorInfoSuccess](state, payload) {
        state.isLoading = false
        state.monitorInfo = payload
        state.validationErrors = null
    },
    [mutationTypes.getMonitorInfoFailure](state, payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getNewTasksStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.getNewTasksSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getNewTasksFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getOverdueTasksStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.getOverdueTasksSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getOverdueTasksFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getActiveClientsStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.getActiveClientsSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getActiveClientsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getNodealClientsStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.getNodealClientsSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getNodealClientsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getNotaskClientsStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.getNotaskClientsSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getNotaskClientsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getListDealStart](state) {
        state.isLoading = true
        state.listDeal = null
    },
    [mutationTypes.getListDealSuccess](state, payload) {
        state.isLoading = false
        state.listDeal = payload
        state.validationErrors = null
    },
    [mutationTypes.getListDealFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getListTaskStart](state) {
        state.isLoading = true
        state.listTask = null
    },
    [mutationTypes.getListTaskSuccess](state, payload) {
        state.isLoading = false
        state.listTask = payload
        state.validationErrors = null
    },
    [mutationTypes.getListTaskFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getDealsStageStart](state) {
        state.isLoading = true
        state.list = null
    },
    [mutationTypes.getDealsStageSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getDealsStageFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getMonitorHistoryStart](state) {
        state.isLoading = true
        state.monitorHistory = null
    },
    [mutationTypes.getMonitorHistorySuccess](state, payload) {
        state.isLoading = false
        state.monitorHistory = payload
        state.validationErrors = null
    },
    [mutationTypes.getMonitorHistoryFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },


    [mutationTypes.setOpenedStart](state) {
        state.isLoading = true
        state.opened = null
    },
    [mutationTypes.setOpenedSuccess](state, payload) {
        state.isLoading = false
        state.opened = payload
        state.validationErrors = null
    },
    [mutationTypes.setOpenedFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },
    

    
}

const actions = {
    [monitorActionTypes.getNewRequests](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getNewRequestsStart)
            monitorApi
                .getNewRequests(data)
                .then(response => {
                    context.commit(mutationTypes.getNewRequestsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getNewRequestsFailure,response)
                })
        })
    },

    [monitorActionTypes.getProgressRequests](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getProgressRequestsStart)
            monitorApi
                .getProgressRequests(data)
                .then(response => {
                    context.commit(mutationTypes.getProgressRequestsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getProgressRequestsFailure,response)
                })
        })
    },

    [monitorActionTypes.getNotaskDeals](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getNotaskDealsStart)
            monitorApi
                .getNotaskDeals(data)
                .then(response => {
                    context.commit(mutationTypes.getNotaskDealsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getNotaskDealsFailure,response)
                })
        })
    },

    [monitorActionTypes.getActiveDeals](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getActiveDealsStart)
            monitorApi
                .getActiveDeals(data)
                .then(response => {
                    context.commit(mutationTypes.getActiveDealsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getActiveDealsFailure,response)
                })
        })
    },

    [monitorActionTypes.getMonitorInfo](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getMonitorInfoStart)
            monitorApi
                .getMonitorInfo(data)
                .then(response => {
                    context.commit(mutationTypes.getMonitorInfoSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getMonitorInfoFailure, response)
                })
        })
    },

    [monitorActionTypes.getNewTasks](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getNewTasksStart)
            monitorApi
                .getNewTasks(data)
                .then(response => {
                    context.commit(mutationTypes.getNewTasksSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getNewTasksFailure,response)
                })
        })
    },

    [monitorActionTypes.getOverdueTasks](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getOverdueTasksStart)
            monitorApi
                .getOverdueTasks(data)
                .then(response => {
                    context.commit(mutationTypes.getOverdueTasksSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getOverdueTasksFailure,response)
                })
        })
    },

    [monitorActionTypes.getActiveClients](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getActiveClientsStart)
            monitorApi
                .getActiveClients(data)
                .then(response => {
                    context.commit(mutationTypes.getActiveClientsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getActiveClientsFailure,response)
                })
        })
    },

    [monitorActionTypes.getNodealClients](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getNodealClientsStart)
            monitorApi
                .getNodealClients(data)
                .then(response => {
                    context.commit(mutationTypes.getNodealClientsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getNodealClientsFailure,response)
                })
        })
    },

    [monitorActionTypes.getNotaskClients](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getNotaskClientsStart)
            monitorApi
                .getNotaskClients(data)
                .then(response => {
                    context.commit(mutationTypes.getNotaskClientsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getNotaskClientsFailure,response)
                })
        })
    },

    [monitorActionTypes.getListDeal](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getListDealStart)
            monitorApi
                .getListDeal(data)
                .then(response => {
                    context.commit(mutationTypes.getListDealSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getListDealFailure,response)
                })
        })
    },

    [monitorActionTypes.getListTask](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getListTaskStart)
            monitorApi
                .getListTask(data)
                .then(response => {
                    context.commit(mutationTypes.getListTaskSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getListTaskFailure,response)
                })
        })
    },

    [monitorActionTypes.getDealsStage](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getDealsStageStart)
            monitorApi
                .getDealsStage(data)
                .then(response => {
                    context.commit(mutationTypes.getDealsStageSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getDealsStageFailure,response)
                })
        })
    },

    [monitorActionTypes.getMonitorHistory](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getMonitorHistoryStart)
            monitorApi
                .getMonitorHistory(data)
                .then(response => {
                    context.commit(mutationTypes.getMonitorHistorySuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getMonitorHistoryFailure,response)
                })
        })
    },

    [monitorActionTypes.setOpened](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.setOpenedStart)
            monitorApi
                .setOpened(data)
                .then(response => {
                    context.commit(mutationTypes.setOpenedSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.setOpenedFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}